sap.ui.define(["sap/ui/core/library", 'sap/uxap/BlockBase'], function (coreLibrary, BlockBase) {
	"use strict";

	var ViewType = coreLibrary.mvc.ViewType;

	var LeaveTypes = BlockBase.extend("com.reply.leaviosa.blocks.admin.LeaveTypes", {
		metadata: {
			views: {
				Collapsed: {
					viewName: "com.reply.leaviosa.blocks.admin.LeaveTypes",
					type: ViewType.XML
				},
				Expanded: {
					viewName: "com.reply.leaviosa.blocks.admin.LeaveTypes",
					type: ViewType.XML
				}
			}
		}
	});

	return LeaveTypes;
});